import React, { useState, useEffect, useRef } from 'react';
import { Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import { makeStyles, useTheme, useMediaQuery } from '@material-ui/core';
import NavBar from './NavBar';
import TopBar from './TopBar';
import Support from 'src/views/support';
import useAuth from 'src/hooks/useAuth';
import { useDispatch, useSelector } from 'src/store';
import { closeToggle } from 'src/slices/toggle';
import { logout } from 'src/slices/auth';
import NetworkContext from 'src/contexts/NetworkContext';
import NetworkDetector from './NetworkDetector';
import IdleModal from './Dialog/index';
import IdleTimer from 'react-idle-timer';
import UnActivatedUser from 'src/views/errors/UnActivatedUser';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    display: 'flex',
    height: '100%',
    overflow: 'hidden',
    width: '100%',
    paddingBottom: 40
  },
  wrapper: {
    display: 'flex',
    flex: '1 1 auto',
    overflow: 'hidden',
    paddingTop: 64,
    [theme.breakpoints.up('lg')]: {
      paddingLeft: 256
    }
  },
  contentContainer: {
    display: 'flex',
    flex: '1 1 auto',
    overflow: 'hidden'
  },
  content: {
    flex: '1 1 auto',
    height: '100%',
    overflow: 'auto'
  }
}));

let countdownInterval;
let timeout;
const DashboardLayout = ({ children }) => {
  const dispatch = useDispatch();
  const {
    user: { userAccountStatus }
  } = useAuth();
  const classes = useStyles();
  const { openTour } = useSelector((state) => state.toggle);
  const { sessionTime } = useSelector((state) => state.sessionDuration);
  const [isMobileNavOpen, setMobileNavOpen] = useState(false);
  const theme = useTheme();
  const mobile = useMediaQuery(theme.breakpoints.down('md'));
  const [openModal, setOpenModal] = useState(false);
  const [timeoutCounter, setTimeoutCounter] = useState(0);
  const idleTimer = useRef(null);

  const clearSessionTimeout = () => {
    clearTimeout(timeout);
  };

  const clearSessionInterval = () => {
    clearInterval(countdownInterval);
  };

  const handleContinue = () => {
    setOpenModal(false);
    clearSessionInterval();
    clearSessionTimeout();
  };

  const handleActive = () => {
    if (!openModal) {
      clearSessionInterval();
      clearSessionTimeout();
    }
  };

  const handleIdle = () => {
    const timeDelay = 1000 * 1;
    if (!openModal) {
      timeout = setTimeout(() => {
        let countDown = 10;
        setOpenModal(true);
        setTimeoutCounter(countDown);
        countdownInterval = setInterval(() => {
          if (countDown > 0) {
            setTimeoutCounter(--countDown);
          } else {
            handleLogout();
          }
        }, 1000);
      }, timeDelay);
    }
  };

  const handleLogout = () => {
    clearSessionInterval();
    clearSessionTimeout();
    dispatch(logout());
  };

  // sidenav lifecycle hook
  useEffect(() => {
    if (mobile && openTour) {
      setMobileNavOpen(true);
    }
  }, [openTour, mobile]);

  // autoLogout @ invalidToken lifecycle hook
  useEffect(() => {
    const handleInvalidToken = (e) => {
      if (e.key === 'current_store' && e.oldValue && !e.newValue) {
        dispatch(logout());
      }
    };

    window.addEventListener('storage', handleInvalidToken);

    return function cleanup() {
      window.removeEventListener('storage', handleInvalidToken);
    };
  }, [dispatch, logout]);

  // session timer lifecycle hook
  useEffect(() => {
    handleContinue();
    return () => {
      handleContinue();
    };
  }, [sessionTime]);

  // Redirect suspended user to path: /app/suspended
  if (userAccountStatus === 'f') {
    return <Redirect to="/app/suspended" />;
  }

  return (
    <NetworkContext>
      <div className={classes.root} onClick={() => dispatch(closeToggle())}>
        <TopBar onMobileNavOpen={() => setMobileNavOpen(true)} />
        <NetworkDetector />
        <NavBar
          onMobileClose={() => setMobileNavOpen(false)}
          openMobile={isMobileNavOpen}
          onOpenMobile={() => setMobileNavOpen(true)}
        />
        <div className={classes.wrapper}>
          <div className={classes.contentContainer}>
            <div className={classes.content}>{children}</div>
            <Support />
          </div>
        </div>
      </div>
      {/*   <IdleTimer
        ref={idleTimer}
        onActive={handleActive}
        onIdle={handleIdle}
        debounce={250}
        timeout={sessionTime}
      />
      <IdleModal
        open={openModal}
        counter={timeoutCounter}
        handleContinue={handleContinue}
        handleLogout={handleLogout}
   /> */}

      {/** user status modal */}
      {userAccountStatus === 'w' && <UnActivatedUser />}
    </NetworkContext>
  );
};

DashboardLayout.propTypes = {
  children: PropTypes.node
};

export default DashboardLayout;
